import TabsContainer from "components/TabsContainer";
import Tab from "components/Tab";
import TemplateBuilderTab from "features/appraisals/TemplateBuilderTab";
import AppraisalCycleTab from "features/appraisals/AppraisalCycleTab";
import ManagerReviewTab from "features/appraisals/ManagerReviewTab";
import SelfReviewTab from "features/appraisals/SelfReviewTab";
import PeerReviewTab from "features/appraisals/PeerReviewTab";

const Appraisals = () => {
  return (
    <div className="mt-5">
      <TabsContainer defaultTab={0}>
        <Tab isActive={true} title="Template Builder" key="template-builder">
          <TemplateBuilderTab />
        </Tab>
        <Tab isActive={false} title="Appraisal Cycle" key="appraisal-cycle">
          <AppraisalCycleTab />
        </Tab>
        <Tab isActive={false} title="Manager Reviews" key="manager-reviews">
          <ManagerReviewTab />
        </Tab>
        <Tab isActive={false} title="Self Reviews" key="self-reviews">
          <SelfReviewTab />
        </Tab>
        <Tab isActive={false} title="Peer Reviews" key="peer-reviews">
          <PeerReviewTab />
        </Tab>
      </TabsContainer>
    </div>
  );
};

export default Appraisals;
